import { useTranslation } from 'react-i18next'

import {
	useDislikeReasonMutation,
	useLikeReasonMutation
} from '@wwt/api/base/reason'

import { ReasonType } from '@wwt/entities/reason'

import { useToast } from '@/shared/lib/hooks/useToast'

type SubmitData = {
	offerId: string
	reason: string[]
	detailedDescription?: string
}

export const useReasonSubmit = (type: ReasonType) => {
	const { toast } = useToast()
	const { t } = useTranslation('translation')

	const likeReason = useLikeReasonMutation()
	const dislikeReason = useDislikeReasonMutation()

	return (data: SubmitData) => {
		const submitToast = toast({
			layer: 'modals',
			duration: Infinity,
			description: t('toastTexts.loading')
		})

		const showSuccessToast = () => {
			submitToast.update({
				duration: 5000,
				variant: 'success',
				description: t('toastTexts.successSaved')
			})
		}

		const showErrorToast = () => {
			submitToast.update({
				duration: 5000,
				variant: 'error',
				description: t('toastTexts.somethingWentWrong')
			})
		}

		if (type === ReasonType.like) {
			likeReason
				.mutateAsync(data)
				.then(showSuccessToast)
				.catch(err => {
					showErrorToast()
					throw new Error(err)
				})
		} else if (type === ReasonType.dislike) {
			dislikeReason
				.mutateAsync(data)
				.then(showSuccessToast)
				.catch(err => {
					showErrorToast()
					throw new Error(err)
				})
		}
	}
}
